
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-customer-service-2-line',
      title: 'Comunicação e Aquisição de Leads',
      description: 'Atendimento e captura de potenciais clientes através de Inteligência Artificial e automações de processos avançadas.',
      features: ['IA Conversacional', 'Automação de Processos', 'Captura Inteligente']
    },
    {
      icon: 'ri-global-line',
      title: 'Prospecção Omnichannel',
      description: 'Voice AI, LinkedIn, Email, WhatsApp e Redes Sociais com fluxos integrados e hiper personalizados.',
      features: ['Voice AI Imersiva', 'LinkedIn Automation', 'Email Marketing', 'WhatsApp IA']
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Qualificação de Leads',
      description: 'Inteligência Artificial para qualificar e entender as necessidades de cada oportunidade (SDR + BDR).',
      features: ['IA de Qualificação', 'Análise Comportamental', 'Scoring Automático']
    },
    {
      icon: 'ri-flow-chart',
      title: 'Processo End-to-End',
      description: 'Gestão completa desde o mapeamento do ICP até análise de reuniões realizadas com IA.',
      features: ['Mapeamento ICP', 'Mineração de Dados', 'Análise de Reuniões']
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Indicadores e Insights',
      description: 'Métricas de desempenho e análises detalhadas garantindo total visibilidade dos resultados.',
      features: ['Dashboard Avançado', 'Relatórios IA', 'Análise Preditiva']
    }
  ];

  return (
    <section id="services" className="py-12 bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Nossos Serviços
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Soluções completas de IA para revolucionar sua estratégia de prospecção e vendas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-2xl p-6 hover:bg-gray-800/70 transition-all duration-300 hover:scale-105 hover:shadow-2xl group h-full flex flex-col"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className={`${service.icon} text-lg text-white`}></i>
                </div>
                
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-400 transition-colors leading-tight">{service.title}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">{service.description}</p>
                </div>
              </div>
              
              <div className="mt-auto">
                <ul className="space-y-1.5">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-xs text-gray-300">
                      <i className="ri-check-line text-green-400 mr-2 flex-shrink-0 text-sm"></i>
                      <span className="leading-tight">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Technology Stack */}
        <div className="mt-20 text-center">
          <h3 className="text-2xl font-bold text-white mb-8">Tecnologias que Utilizamos</h3>
          <div className="flex flex-wrap justify-center items-center gap-8 opacity-60">
            <div className="flex items-center space-x-2 text-gray-400">
              <i className="ri-brain-line text-2xl"></i>
              <span>Machine Learning</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-400">
              <i className="ri-voice-recognition-line text-2xl"></i>
              <span>Voice AI</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-400">
              <i className="ri-chat-3-line text-2xl"></i>
              <span>NLP</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-400">
              <i className="ri-robot-line text-2xl"></i>
              <span>Automation</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-400">
              <i className="ri-database-2-line text-2xl"></i>
              <span>Big Data</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
